<template>
  <div>
    <CkEditorFormGroup
        :value="value.content"
        name="content"
        label="Content"
        :error="(errors.content || [])[0]"
        @input="emit('content', $event)"
    />
  </div>
</template>

<script>
import SelectFormGroup from '@/vendor/forms/FormGroups/Block/Select'
import CkEditorFormGroup from '@/vendor/forms/FormGroups/Block/CkEditor'

export default {
  components: {SelectFormGroup, CkEditorFormGroup},

  props: {
    value: {
      required: true
    },

    errors: {
      required: true
    }
  },

  methods: {
    emit(key, value) {
      this.$emit('input', {...this.value, [key]: value})
    },
  }
}
</script>
